module.exports = __webpack_public_path__ + "static/media/wave-7.e0fcfd6a.svg";